import { useEffect, useState } from "react";
import { previewDescription, previewImage, previewTitle } from "./deckRegistry";

/* Slik ser lenken ut i iMessage/Slack/LinkedIn. Bildet er deckets cover rendret på serveren — å vise det her varmer også cachen,
   så første crawler får svar med en gang. Debounce: én rendering per pause i skrivingen, ikke per tastetrykk. */
export const LinkPreview = ({ deck, mottaker, token }) => {
  const [src, setSrc] = useState(null);
  const [state, setState] = useState("idle");
  useEffect(() => {
    setState("loading");
    const t = setTimeout(() => setSrc(previewImage(deck, token)), 400);
    return () => clearTimeout(t);
  }, [deck, token]);

  const host = window.location.host.replace(/^www\./, "");
  return (
    <figure className="pdadm-preview" data-testid="pdadm-preview">
      <div className={`pdadm-preview-img ${state}`}>
        {src && <img src={src} alt="" onLoad={() => setState("ready")} onError={() => setState("error")} data-testid="pdadm-preview-img" />}
        {state !== "ready" && <span className="pdadm-preview-skel">{state === "error" ? "Forhåndsvisning utilgjengelig" : "Rendrer cover …"}</span>}
      </div>
      <figcaption>
        <span className="t" data-testid="pdadm-preview-title">{previewTitle(deck, mottaker)}</span>
        <span className="d">{previewDescription(deck, mottaker)}</span>
        <span className="h">{host}</span>
      </figcaption>
    </figure>
  );
};
